/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualCapexDto } from '../../models/backend-actual-capex-dto';
import { BackendActualCapexRequestDto } from '../../models/backend-actual-capex-request-dto';

export interface MonitoringActualsCapexsUpdate$FormData$Params {
  id: number;
  body: BackendActualCapexRequestDto;
}

export function monitoringActualsCapexsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsCapexsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualCapexDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsCapexsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualCapexDto>;
    }),
  );
}

monitoringActualsCapexsUpdate$FormData.PATH = '/api/monitoring/actuals/capexs/{id}/';
